/**
 * API for SavedState
 * @module api/savedState
 */

import Settings from "../settings";

const API_VERSION = "v1";

export const getSavedState = userId =>
  fetch(`${Settings.camioApiUrl}${API_VERSION}/lucisavedstate/${userId}`, {
    mode: "cors"
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject({ error: "Error in getSavedState" });
  });

export const saveState = (userId, data) => {
  const payload = {
    userId,
    data
  };

  return fetch(`${Settings.camioApiUrl}${API_VERSION}/lucisavedstate/`, {
    mode: "cors",
    method: "put",
    dataType: "json",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  }).then(response => {
    if (response.ok) {
      return true;
    }
    return Promise.reject({ error: "Error while saving luci state." });
  });
};



// WEBPACK FOOTER //
// ./app/api/savedState.js